<template>
    <v-layout>
        <v-flex class="main-footer mt-4">
            <v-container>
                <!-- <v-flex class="about_social text-xs-center">
                    <img :src="logo" style="width:150px;">
                </v-flex> -->
                
                <v-flex class="text-center footer-bottom-data text-xs-center">
                    <p>© Copyright 2020 24MM Media</p>
                </v-flex>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
  import firebase from 'firebase'
  export default {
    name:'Navbar',
    data(){
     return{
        logo:null,       
    }
  },  
  created(){
        var db = firebase.firestore();   
      
        // Logo   
        db.collection("settings").doc('config').onSnapshot(doc =>{
          this.logo = doc.data().logo            
        })

  }
}
</script>

<style scoped>
/*----Footer------*/
.main-footer { 
    background-color: #313231;
    color: #b6b6b6;
    border-top: 5px solid #345B2C;
}

.main-footer .container{
    padding-top:0!important;
    padding-bottom:0!important;
}
.main-footer .about_social{
    padding:20px 0;
}
.main-footer a{
   text-decoration: none;
   color: #b6b6b6;
}
.main-footer i{
    margin-right: 5px;
}
.footer-bottom-data{
	border-top: 5px solid #345B2C;
}
.footer-bottom-data p {
    padding: 15px 0;
    margin-bottom: 0;
}

.about_social .v-icon {
    border-radius: 50%;
    color: #b6b6b6;
    display: inline-block;
    font-size: 20px;
    height: 40px;
    width: 40px;
    line-height: 42px;
    border:1px solid #b6b6b6;
    margin: 0 3px 0px 0;
    text-align: center;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    cursor: pointer;
}
.about_social a {
    border-radius: 50%;
    color: #b6b6b6;
    display: inline-block;
    font-size: 20px;
    height: 40px;
    width: 40px;
    line-height: 42px;
    border:1px solid #b6b6b6;
    margin: 0 3px 3px 0;
    text-align: center;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
}

.about_social .facebook:hover {
    background-color: #3B5998;
    color: #fff;
    border:1px solid #3B5998;
    transition: .4s;
}

.about_social .twitter:hover {
    color: #fff;
    background-color: #00aced;
    border:1px solid #00aced;
    transition: .4s;
}

.about_social .google-plus:hover {
    color: #fff;
    background-color: #dd4b39;
    border:1px solid #dd4b39;
    transition: .4s;
}

.about_social .youtube:hover {
    color: #fff;
    background-color: #bb0000;
    border:1px solid #bb0000;
    transition: .4s;
}

</style>


// WEBPACK FOOTER //
// src/components/shop/sections/Footer.vue